import { render, staticRenderFns } from "./analysisIndvidual.vue?vue&type=template&id=48c4a09e&scoped=true"
import script from "./analysisIndvidual.vue?vue&type=script&lang=js"
export * from "./analysisIndvidual.vue?vue&type=script&lang=js"
import style0 from "./analysisIndvidual.vue?vue&type=style&index=0&id=48c4a09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4a09e",
  null
  
)

export default component.exports